import { formatedDate } from '@/Features/Core/utils/format';
import {
  ArrowDownTrayIcon,
  SparklesIcon,
  TrashIcon,
} from '@heroicons/react/24/outline';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import { IconButton, Tooltip } from '@mui/material';
import { memo } from 'react';
import { getIconFile, getLabel } from '../utils/fileHelpers';

/**
 * Individual image list item component
 * @param {Object} props - Component props
 * @returns {JSX.Element} Image list item
 */
const ImageListItem = ({
  file,
  index,
  selectedIndex,
  theme,
  noVision,
  onFileClick,
  onBadInteraction,
  onDeleteFile,
}) => {
  const isSelected = selectedIndex.includes(index);

  return (
    <div
      key={index}
      className="p-1 border-b border-b-platinum relative"
      onClick={() => {
        if (!(noVision && file.type === 'image')) {
          onFileClick(index);
        }
      }}
    >
      <div
        className={`flex items-center cursor-pointer justify-between w-full ${
          isSelected
            ? 'bg-lavender dark:bg-ship-grey font-medium'
            : 'font-normal'
        } ${
          noVision &&
          file.type === 'image' &&
          'opacity-20 dark:opacity-10 blur-[1px] select-none'
        } p-1 rounded`}
      >
        {!isSelected ? (
          getIconFile(file.type, file, theme)
        ) : (
          <div className="w-16 flex items-center justify-center">
            <CheckCircleIcon color="#464BBA" className="w-7 h-7" />
          </div>
        )}

        <div className="ml-2 text-sm">
          <p
            className={`block whitespace-nowrap truncate w-[120px] overflow-hidden ${
              theme === 'dark' ? 'text-crystal-bell' : 'text-raisin-black'
            }`}
          >
            {file.name}
          </p>
        </div>

        <div
          className={`hidden md:block ml-2 ${
            theme === 'dark' ? 'text-crystal-bell' : 'text-raisin-black'
          } text-sm`}
        >
          {getLabel(file.type, file.size)}
        </div>

        <div
          className={`hidden md:block ml-2 ${
            theme === 'dark' ? 'text-crystal-bell' : 'text-raisin-black'
          } text-sm`}
        >
          {formatedDate(file.created, 'DD/MM/YYYY')}
        </div>

        <div
          className={`ml-1 ${
            theme === 'dark' ? 'text-crystal-bell' : 'text-raisin-black'
          } text-sm flex items-center gap-1`}
        >
          <Tooltip title="Download image" arrow placement="top">
            <IconButton
              onClick={(e) => e.stopPropagation()}
              component="a"
              target="_blank"
              href={file.url}
            >
              <ArrowDownTrayIcon
                className={`w-4 h-4 ${
                  theme === 'dark' ? 'text-crystal-bell' : 'text-raisin-black'
                }`}
              />
            </IconButton>
          </Tooltip>

          <Tooltip title="Delete image" arrow placement="top">
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                onDeleteFile(file);
              }}
            >
              <TrashIcon
                className={`w-4 h-4 ${
                  theme === 'dark' ? 'text-crystal-bell' : 'text-raisin-black'
                }`}
              />
            </IconButton>
          </Tooltip>
        </div>
      </div>

      {noVision && file.type === 'image' && (
        <div className="absolute top-0 left-0 text-black dark:text-white w-full h-full flex justify-center items-center select-none">
          <SparklesIcon
            className={`h-6 w-6 mr-5 ${
              theme === 'dark' ? 'text-crystal-bell' : 'text-raisin-black'
            }`}
          />
          <div
            className={`text-center not-italic ${
              theme === 'dark' ? 'text-crystal-bell' : 'text-raisin-black'
            }`}
          >
            Can't add images in this{' '}
            <span
              onClick={() =>
                onBadInteraction({
                  reason: 'bad model',
                })
              }
              className="text-violet-blue font-semibold underline cursor-pointer"
            >
              Model (LLM)
            </span>
            .
          </div>
        </div>
      )}
    </div>
  );
};

export default memo(ImageListItem);
